export const createCandidateFieldConfiguration = [
  {
    name: "firstName",
    label: "First Name",
    type: "text",
    validation: {
      required: "First name is required",
    },
  },
  {
    name: "lastName",
    label: "Last Name",
    type: "text",
    validation: {
      required: "Last name is required",
    },
  },
  {
    name: "phoneNumber",
    label: "Phone Number",
    type: "text",
    validation: {
      required: "Phone number is required",
    },
  },
  {
    name: "position",
    label: "Position",
    type: "text",
    validation: {
      required: "Position is required",
    },
  },
  {
    name: "email",
    label: "Email",
    type: "text",
    validation: {
      required: "Email is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid email format",
      },
    },
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { label: "NEW", value: "NEW" },
      { label: "SCHEDULED", value: "SCHEDULED" },
      { label: "HIRED", value: "HIRED" },
      { label: "REJECTED", value: "REJECTED" },
      { label: "RESERVED", value: "RESERVED" },
    ],
  },
];

export const createCandidateInitialValues = {
  firstName: "",
  lastName: "",
  phoneNumber: "",
  position: "",
  email: "",
  status: "NEW",
  cv: null,
};

export const updateCandidateFieldConfiguration =
  createCandidateFieldConfiguration;

export const cvValidation = {
  required: "CV is required",
  validate: {
    isPdf: (files: FileList) => {
      const file = files && files[0];
      if (!file) return "CV is required";
      const ext = file.name.split(".").pop()?.toLowerCase();
      return ext === "pdf" || "Only PDF files are allowed";
    },
    fileSize: (files: FileList) => {
      const file = files && files[0];
      if (!file) return "CV is required";
      return file.size <= 5 * 1024 * 1024 || "File size exceeds limit (5MB)";
    },
  },
};
